import { Navigate } from "react-router-dom";
import { useAuth } from "@/services/auth";
import { AuthStatus } from "@/services/api";
import type { FC, PropsWithChildren } from "react";

export const AuthRoute: FC<PropsWithChildren> = ({ children }) => {
  const { isAuthenticated, authStatus } = useAuth();

  if (!isAuthenticated || authStatus !== AuthStatus.ACTIVE) {
    return <>{children}</>;
  }
  return <Navigate to="/dashboards" replace />;
};
